export const Types = {
  SET_USER: 'SET_USER',
  SET_DECKS: 'SET_DECKS',
  SET_RECENT_DECKS: 'SET_RECENT_DECKS',
  CREATE_DECK: 'CREATE_DECK',
  DELETE_DECK: 'DELETE_DECK',
  UPDATE_DECK: 'UPDATE_DECK'
}
